module.exports = __webpack_public_path__ + "static/canto-7ee6ce96e9ec78a22ef51f01d7ef5ff3.png";